<div id="" mat-dialog-content class="pb-0 m-0 mat-card " style="padding:0px  !important" fxLayout="column">

	<form [formGroup]="form" style="padding-left: 18px;padding-right: 18px;" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form" >
		<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"  fxFlex="1 0 auto">
			<div fxFlex="100">
				<mat-accordion>
					<mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
						<mat-expansion-panel-header>
							<mat-panel-title>
								Charger : {{params.data.name}}
							</mat-panel-title>
							<mat-panel-description> </mat-panel-description>
						</mat-expansion-panel-header>
					</mat-expansion-panel>
				</mat-accordion>
			</div>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"  fxFlex="1 0 auto" style="padding-top:10px">	
			<mat-form-field appearance="outline" fxFlex="30" class="pr-4">
				<mat-label>Search</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="" #input autocomplete="password">
            </mat-form-field>
			<mat-form-field appearance="outline" fxFlex="30" class="pr-4">
                <mat-label>From Date</mat-label>
                <input matInput [matDatepicker]="fDate" formControlName="fromDate" #fromDate [max]="currDate" disabled>
                <mat-datepicker-toggle matSuffix [for]="fDate"></mat-datepicker-toggle>
                <mat-datepicker #fDate disabled="false"></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="30" class="pr-4">
                <mat-label>To Date</mat-label>
                <input matInput [matDatepicker]="tDate" formControlName="toDate"
                   [min]="!!form.value.fromDate ? form.value.fromDate._d : '2020-01-01'" [max]="currDate" disabled>
                <mat-datepicker-toggle matSuffix [for]="tDate"></mat-datepicker-toggle>
                <mat-datepicker #tDate disabled="false"></mat-datepicker>
            </mat-form-field>
			<div fxFlex="10" >
            <!-- <button mat-raised-button color="primary" class="m-t-8" (click)="getChargerLogs()">Filter</button>
            filter_list -->
            <mat-icon color="primary" matTooltip="Filter"
                (click)="getChargerLogs()" style="cursor:pointer; ">filter_alt</mat-icon>
            <mat-icon color="primary" matTooltip="Refresh"
                (click)="getChargerLogs()" style="cursor:pointer;">refresh</mat-icon>
          </div>
		</div>
	</form>
	<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"  fxFlex="1 0 auto" style="overflow: scroll;">
			<div >
				<div class="mat-elevation-z2"  >
					<table mat-table [dataSource]="dataSource" matSort  >
						<ng-container matColumnDef="action">
							<th mat-header-cell   style="width: 150px;" *matHeaderCellDef mat-sort-header > Action </th>
							<td mat-cell *matCellDef="let row"> {{row.action}} </td>
						</ng-container>
						<!-- <ng-container matColumnDef="charger_id"  >
							<th mat-header-cell style="width: 150px;" *matHeaderCellDef mat-sort-header> Charger ID </th>
							<td mat-cell *matCellDef="let row"> {{row.charger_id}} </td>
						</ng-container> -->
						<ng-container matColumnDef="charger_request"  >
					<th mat-header-cell style="width: 250px;" *matHeaderCellDef mat-sort-header> Request </th>
					<td mat-cell *matCellDef="let row"> {{row.charger_request}} </td>
						</ng-container>
						<ng-container matColumnDef="charger_response"  >
					<th mat-header-cell style="width: 350px;" *matHeaderCellDef mat-sort-header> Response </th>
					<td mat-cell *matCellDef="let row"> {{row.charger_response}} </td>
						</ng-container>
						<ng-container matColumnDef="request_date" >
							<th mat-header-cell  style="width: 300px;" *matHeaderCellDef mat-sort-header> Request Date </th>
							<td mat-cell *matCellDef="let row"> {{row.request_date}} </td>
						</ng-container>
						<ng-container matColumnDef="response_date"  >
							<th mat-header-cell style="width: 300px;" *matHeaderCellDef mat-sort-header> Response Date </th>
							<td mat-cell *matCellDef="let row"> {{row.response_date}} </td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="displayedColumns; "  ></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
		  			</table>
					<mat-paginator [pageSizeOptions]="[50, 100, 150, 200]"></mat-paginator>
				</div>
			</div>
	</div>
	
	
</div>